import { gql } from '@apollo/client';
import { BUDGET_CATEGORY_BASIC } from './budgetCategories';

// Fragment para información básica de partida
export const BUDGET_ITEM_BASIC = gql`
  fragment BudgetItemBasic on BudgetItem {
    id
    code
    description
    unit
    unitPrice
    isActive
    budgetCategoryId
    actionBudgetItemsCount
    usageCount
    createdAt
    updatedAt
  }
`;

// Fragment para partida con categoría
export const BUDGET_ITEM_WITH_CATEGORY = gql`
  fragment BudgetItemWithCategory on BudgetItem {
    ...BudgetItemBasic
    budgetCategory {
      ...BudgetCategoryBasic
    }
  }
  ${BUDGET_ITEM_BASIC}
  ${BUDGET_CATEGORY_BASIC}
`;

// Obtener partidas con filtros y paginación
export const GET_BUDGET_ITEMS = gql`
  query GetBudgetItems(
    $filters: BudgetItemFilters
    $pagination: PaginationOptions
  ) {
    budgetItems(filters: $filters, pagination: $pagination) {
      items {
        ...BudgetItemWithCategory
      }
      pagination {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
  ${BUDGET_ITEM_WITH_CATEGORY}
`;

// Obtener una partida por ID (simplificada y segura)
export const GET_BUDGET_ITEM = gql`
  query GetBudgetItem($id: ID!) {
    budgetItem(id: $id) {
      ...BudgetItemWithCategory
    }
  }
  ${BUDGET_ITEM_WITH_CATEGORY}
`;

// Obtener una partida por código
export const GET_BUDGET_ITEM_BY_CODE = gql`
  query GetBudgetItemByCode($code: String!) {
    budgetItemByCode(code: $code) {
      ...BudgetItemWithCategory
    }
  }
  ${BUDGET_ITEM_WITH_CATEGORY}
`;

// Buscar partidas
export const SEARCH_BUDGET_ITEMS = gql`
  query SearchBudgetItems(
    $searchTerm: String!
    $categoryId: String
    $limit: Int
  ) {
    searchBudgetItems(
      searchTerm: $searchTerm
      categoryId: $categoryId
      limit: $limit
    ) {
      ...BudgetItemWithCategory
    }
  }
  ${BUDGET_ITEM_WITH_CATEGORY}
`;

// Obtener partidas por categoría
export const GET_BUDGET_ITEMS_BY_CATEGORY = gql`
  query GetBudgetItemsByCategory($categoryId: ID!) {
    budgetItemsByCategory(categoryId: $categoryId) {
      ...BudgetItemWithCategory
    }
  }
  ${BUDGET_ITEM_WITH_CATEGORY}
`;

// Obtener estadísticas de partidas (solo COEX/ADMIN)
export const GET_BUDGET_ITEMS_STATS = gql`
  query GetBudgetItemsStats {
    budgetItemsStats {
      totalItems
      activeItems
      inactiveItems
      usedItems
      unusedItems
      priceStats {
        average
        minimum
        maximum
      }
      itemsByCategory {
        id
        code
        name
        color
        budgetItemsCount
      }
    }
  }
`;

// Obtener partidas más utilizadas
export const GET_MOST_USED_BUDGET_ITEMS = gql`
  query GetMostUsedBudgetItems($limit: Int) {
    mostUsedBudgetItems(limit: $limit) {
      ...BudgetItemWithCategory
    }
  }
  ${BUDGET_ITEM_WITH_CATEGORY}
`;
